"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistanceInKilometers = exports.getDistanceInKm = exports.KM_IN_DEGREE = void 0;
const EARTH_RADIUS_KM = 6371;
const EARTH_LENGTH_KM = 2 * Math.PI * EARTH_RADIUS_KM;
exports.KM_IN_DEGREE = EARTH_LENGTH_KM / 360;
const degreesToRadians = (degrees) => (degrees * Math.PI) / 180;
const getDistanceInKm = (longitude1, latitude1, longitude2, latitude2) => {
    const dLatitude = degreesToRadians(latitude1 - latitude2);
    const dLongitude = degreesToRadians(longitude1 - longitude2);
    const lat1 = degreesToRadians(latitude1);
    const lat2 = degreesToRadians(latitude2);
    // sin²(Δφ/2) + cos φ1 ⋅ cos φ2 ⋅ sin²(Δλ/2)
    const haversine = Math.pow(Math.sin(dLatitude / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dLongitude / 2), 2);
    // 2 ⋅ atan2( √a, √(1−a) ) ⋅ EARTH_RADIUS
    return 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine)) * EARTH_RADIUS_KM;
};
exports.getDistanceInKm = getDistanceInKm;
const getDistanceInKilometers = (point1, point2) => {
    return (0, exports.getDistanceInKm)(point1.longitude, point1.latitude, point2.longitude, point2.latitude);
};
exports.getDistanceInKilometers = getDistanceInKilometers;
//# sourceMappingURL=geoHelper.js.map